import { render, staticRenderFns } from "./Abuse.vue?vue&type=template&id=5a18bbbc"
import script from "./Abuse.vue?vue&type=script&lang=js"
export * from "./Abuse.vue?vue&type=script&lang=js"
import style0 from "./Abuse.vue?vue&type=style&index=0&id=5a18bbbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.29_css-loader@3.6.0_webpack@4.47.0__ejs@3.1.10_66cafdebd9b3647e04b2d113c5f27dd4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports